import {HttpClient} from "../../http/HttpClient.jsx";
import {message} from "antd";

const buildReportBody = (reportName, params) => {
    return {
        reportName,
        ...(Object.keys(params ?? {})?.length ? {params} : {})
    };
};

export const sendAdminReport = async (reportName, params) => {
    const data = buildReportBody(reportName, params);
    const res = await HttpClient.safePost("/admin/api/report/send", data);

    if (res?.error) {
        message.error(res?.error);
    }

    return res;
};

export const sendSystemReport = async (reportName, params) => {
    const data = buildReportBody(reportName, params);
    const res = await HttpClient.safePost("/api/system/report/send", data);

    if (res?.error) {
        message.error(res?.error);
    }

    return res;
};
